import Dropdown from '@jetbrains/ring-ui/components/dropdown/dropdown'
import Popup from '@jetbrains/ring-ui/components/popup/popup'
import React from 'react'

import Icon from '../../../../../common/Icon/Icon'

import styles from './Details.css'

type Props = {
  className?: string
  children?: React.ReactNode
  onHover?: (state: boolean) => void
}

function Details({className, onHover, children}: Props) {
  const hoverIconHandler = (state: boolean) => () => onHover?.(state)
  const clickIconHandler = (event: React.MouseEvent) => event.stopPropagation()

  return (
    <Dropdown
      className={className}
      anchor={() => (
        <div
          role="presentation"
          onClick={clickIconHandler}
          onMouseEnter={hoverIconHandler(true)}
          onMouseLeave={hoverIconHandler(false)}
        >
          <Icon name="info" active="false" title="" className={styles.anchor} aria-label="Info" />
        </div>
      )}
      hoverMode
    >
      <Popup className={styles.detailsPopup}>{children}</Popup>
    </Dropdown>
  )
}

export default Details
